import React, { useContext, useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import SaleItemNavBar from './sale-item-navbar';
import SaleItemDiscountRate from './sale-item-discount-rate';
import ImgPicture from './img-picture';
import { SalePropContext } from './a-sale';
const SaleItem = ({ saleItem }) => {
    const saleProp = useContext(SalePropContext);
    const [onSale, setOnsale] = useState(true);
    const [idName, setIDName] = useState('');
    //
    // ページ内スクロール用のIDを初期化
    useEffect(() => {
        setIDName(`_${saleItem.image_name}`);
    }, [
        saleItem
    ]);
    useEffect(() => {
        if (!saleProp) {
            return;
        }
        // セール用URLが定義されていて、end of saleが定義されていないケース = セール中
        let isOnSale = ((saleItem.url_ns !== undefined && saleItem.eos_ns === undefined) ||
            (saleItem.url_ps4 !== undefined && saleItem.eos_ps4 === undefined) ||
            (saleItem.url_ps5 !== undefined && saleItem.eos_ps5 === undefined) ||
            (saleItem.url_3ds !== undefined && saleItem.eos_3ds === undefined) ||
            (saleItem.url_wiiu !== undefined && saleItem.eos_wiiu === undefined));
        // 上の条件が真でも sale_status == 2ならセール終了
        if (saleProp.sale_status === 2) {
            isOnSale = false;
        }
        setOnsale(isOnSale);
    }, [
        saleItem,
        saleProp
    ]);
    return (React.createElement("div", { className: "sale-item", id: idName },
        React.createElement("div", { className: 'md:hidden sale-item-head' },
            React.createElement("div", { className: 'md:hidden sale-item-head-main' },
                React.createElement(SaleItemDiscountRate, { discountRate: saleItem.discount_rate, isPSPlus: saleItem.discount_rate_without_psplus !== undefined, isOnSale: onSale }))),
        React.createElement("div", { className: "sale-item-layout" },
            React.createElement("div", { className: "sale-item-grid-1" },
                React.createElement("div", { className: "sale-item-image" },
                    React.createElement(ImgPicture, { fileName: `./assets/img/sale-item/${saleItem.image_hash}/${saleItem.image_name}`, alt: saleItem.name, ext: "jpg" }))),
            React.createElement("div", { className: "sale-item-grid-2" },
                React.createElement("div", null,
                    React.createElement(SaleItemDiscountRate, { discountRate: saleItem.discount_rate, isPSPlus: saleItem.discount_rate_without_psplus !== undefined, isOnSale: onSale, cssSubClass: "sm:hidden" }),
                    React.createElement("div", { className: "sale-item-name" }, saleItem.name),
                    (saleItem.discount_rate_without_psplus && onSale) && (React.createElement("div", { className: "text-ex-strong mt-4" }, `※PS Plus未加入者は${saleItem.discount_rate_without_psplus}OFF`)),
                    saleItem.notes && (React.createElement("div", { className: "sale-item-notes sm:hidden" },
                        React.createElement("div", { className: 'text-warn font-bold' }, ReactHtmlParser(saleItem.notes))))),
                React.createElement("div", { className: "sm:hidden" },
                    React.createElement(SaleItemNavBar, { saleItem: saleItem })))),
        saleItem.notes && (React.createElement("div", { className: "sale-item-notes md:hidden" },
            React.createElement("div", { className: 'text-warn font-bold' }, ReactHtmlParser(saleItem.notes)))),
        React.createElement("div", { className: "md:hidden" },
            React.createElement(SaleItemNavBar, { saleItem: saleItem }))));
};
export default SaleItem;
